module.exports = __webpack_public_path__ + "img/MDA_LOGO.80cdb0e8.png";